import React from 'react';
import { Modal, Button, Typography } from '@mui/material';

const DeletionModal = ({ open, onClose, onDelete, type, item }) => {
  const itemType = type === 'post' ? 'cette publication' : type === 'programme' ? 'ce programme' : 'élément'; 

  // Définition de la fonction handleDeleteItem à l'intérieur du composant
  const handleDeleteItem = () => {
    console.log(item);
    if (item) {
      onDelete(item); // Appelle la fonction onDelete passée en prop
    }
    onClose(); // Ferme le modal après la suppression
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ padding: '20px', background: 'white', margin: '20% auto', width: '300px', borderRadius: '8px' }}>
        <Typography variant="h6" gutterBottom>
          Êtes-vous sûr de vouloir supprimer {itemType} ?
        </Typography>
        <Button onClick={onClose} variant="outlined" color="primary" style={{ marginRight: '10px' }}>
          Annuler
        </Button>
        <Button onClick={handleDeleteItem} variant="contained" color="secondary">
          Supprimer
        </Button>
      </div>
    </Modal>
  );
};

export default DeletionModal;
